import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import ParentLogin from "./pages/Parent/ParentLogin";
import BasicInfo from "./pages/Parent/BasicInfo";
import AddressInfo from "./pages/Parent/AddressInfo";
import AcademicInfo from "./pages/Parent/AcademicInfo";
import FileUpload from "./pages/Parent/FileUpload";
import AdmissionRules from "./pages/Parent/AdmissionRules";
import Payment from "./pages/Parent/Payment";
import Dashboard from "./pages/Parent/Dashboard";
import Footer from "./components/parent/Footer";
import Header from "./components/parent/Header";
import PaymentResponse from "./pages/Parent/PaymentResponse";
import ParentInfo from "./pages/Parent/ParentInfo";
import AdminLogin from "./pages/Admin/adminLogin";
import AdminDashboard from "./pages/Admin/adminDashboard";
import AllApplications from "./pages/Admin/allApplications";
import NoPage from "./pages/Error/NoPage";
import ChangePassword from "./pages/Admin/changePassword";
import ChangeParentPassword from "./pages/Admin/changeParentPassword";
import UpdateProfile from "./pages/Admin/updateProfile";
import ParentRegister from "./pages/Parent/ParentRegister";

import AddUser from "./pages/Admin/addUser";
import ManualAdmission from "./pages/Admin/ManualAdmission";

import DetailsPage from "./pages/Admin/DetailsPage";
const buttons = [
  {
    text: "Home",
    onClick: () => (window.location.href = "https://www.ssvkchokkady.org/"),
    color: "bg-blue-500 text-white",
  },
  ...(localStorage.getItem("parentToken")
    ? [
      {
        text: "Dashboard",
        onClick: () => (window.location.href = "/dashboard"),
        color: "bg-blue-500 text-white",
      },
    ]
    : []),
];

const adminRole = localStorage.getItem("adminRole");
const adminToken = localStorage.getItem("adminToken");

// console.log(adminRole,adminToken);

const adminButtons = [
  {
    text: "Home",
    onClick: () => (window.location.href = "https://www.ssvkchokkady.org/"),
    color: "bg-blue-500 text-white",
  },
  ...(adminRole && adminToken
    ? [
      {
        text: "Dashboard",
        onClick: () => (window.location.href = "/admin/dashboard"),
        color: "bg-blue-500 text-white",
      },
    ]
    : []),
];


function ProgressIndicator() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleBackButton = (event) => {
      event.preventDefault();
      navigate(location.pathname, { replace: true });
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [navigate, location]);




  // Define progress steps
  const progressSteps = [
    { text: "Basic Info", route: "/basic-info" },
    { text: "Address Info", route: "/address-info" }, // Dynamic route handled separately
    { text: "Parent Info", route: "/parent-info" },
    { text: "Academic Info", route: "/academic-info" },
    { text: "File Upload", route: "/file-uploads" },
    { text: "Admission Rules", route: "/admission-rules" },
    { text: "Payment", route: "/payment" }
  ];

  // Find the index of the current step
  const currentStepIndex = progressSteps.findIndex((step) =>
    location.pathname.startsWith(step.route)
  );

  return (
    <div className="flex justify-center space-x-4 bg-gray-200 py-3 flex-wrap gap-y-4">
      {progressSteps.map((step, index) => (
        <button
          key={index}
          className={`px-4 py-2 rounded 
            ${index < currentStepIndex ? "bg-green-500 text-white cursor-not-allowed" : ""} 
            ${index === currentStepIndex ? "bg-blue-500 text-white" : ""} 
            ${index > currentStepIndex ? "bg-gray-300 text-black" : ""}`
          }
          disabled={index < currentStepIndex} // Disable previous steps
        >
          {index < currentStepIndex ? "✅ Done" : step.text}
        </button>
      ))}
    </div>
  );
}

// Parent Layout 
function ParentLayout() {
  const location = useLocation();

  // List of form-related pages where header & progress indicator should be shown
  const formRoutes = [
    "/basic-info",
    "/address-info", // Covers dynamic address ID
    "/parent-info",
    "/academic-info",
    "/file-uploads",
    "/admission-rules",
    "/payment"
  ];

  return (
    <div className="flex flex-col min-h-screen">
      {/* ✅ Fix: Show Header on all pages except Dashboard */}
      {!location.pathname.startsWith("/dashboard") && <Header logo="/ssvk-logo.png" buttons={buttons} />}

      {/* ✅ Fix: Show ProgressIndicator on form-related pages */}
      {formRoutes.some(route => location.pathname.startsWith(route)) && <ProgressIndicator />}

      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<ParentLogin />} />
          <Route path="/register" element={<ParentRegister />} />
          <Route path="/basic-info" element={<BasicInfo />} />
          <Route path="/address-info/:id" element={<AddressInfo />} />
          <Route path="/parent-info/:id" element={<ParentInfo />} />
          <Route path="/academic-info/:id" element={<AcademicInfo />} />
          <Route path="/file-uploads/:id" element={<FileUpload />} />
          <Route path="/admission-rules/:id" element={<AdmissionRules />} />
          <Route path="/payment/:id" element={<Payment />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/payment-response/:id" element={<PaymentResponse />} />
          <Route path="*" element={<NoPage />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}

// Admin Layout
function AdminLayout() {
  const location = useLocation();
  return (
    <div className="flex flex-col min-h-screen">
      {!(
        location.pathname.startsWith("/admin/dashboard")
        ||
        ""
        // location.pathname.startsWith("/admin/allApplications")
      ) && <Header logo="/ssvk-logo.png" buttons={adminButtons} />}

      <main className="flex-grow">
        <Routes>
          <Route path="/login" element={<AdminLogin />} />
          <Route path="/dashboard" element={<AdminDashboard />} />
          <Route path="/allApplications" element={<AllApplications />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/change-parent-password" element={<ChangeParentPassword />} />
          <Route path="/update-profile" element={<UpdateProfile />} />
          <Route path="/manual-admission" element={<ManualAdmission />} />
          {/* <Route path="*" element={<NoPage />} /> */}
          <Route path="/add-user" element={<AddUser />} />
          <Route path="/details/:type" element={<DetailsPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
// Main App Component
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/*" element={<ParentLayout />} />
        <Route path="/admin/*" element={<AdminLayout />} />
      </Routes>
    </Router>
  );
}

export default App;
